import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User, Roster } from '../models/xmpp.model';
import { LogService } from './log.service';

declare let Strophe: any;
declare var $: any;

@Injectable()
export class XmppService {
    private BOSH_SERVICE = 'http://192.168.4.112:7070/http-bind/';
    private URL_API_REST = '/xmpp/';
    private connection = null;
    static instance: XmppService = null;
    static isCreating: boolean = false;
    static roster: User[] = [];
    private httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Authorization': '3oWFJH33QbeEe2XG'
        })
      };

    constructor() {
        if (!XmppService.isCreating) {
            throw new Error("This is a real singleton. Get an instance via var socket = NodoSocket.getInsance(); !");
          }
    }

    static get getInstance(): XmppService {
        if (XmppService.instance === null) {
            XmppService.isCreating = true;
            XmppService.instance = new XmppService();
            XmppService.isCreating = false;
        }
    
        console.log("XmppService.instance", XmppService.instance);
        return XmppService.instance;
      }

    get getConnection() {
        return this.connection;
    }

    disconnect() {
        this.connection.options.sync = true; // Switch to using synchronous requests since this is typically called onUnload.
        this.connection.flush();
        this.connection.disconnect();
    }

    init() {
        const onConnect = (status) => {
            if (status == Strophe.Status.CONNECTING) {
                console.log('Strophe is connecting.');
            } else if (status == Strophe.Status.CONNFAIL) {
                console.log('Strophe failed to connect.');
            } else if (status == Strophe.Status.DISCONNECTING) {
                console.log('Strophe is disconnecting.');
            } else if (status == Strophe.Status.DISCONNECTED) {
                console.log('Strophe is disconnected.');
            } else if (status == Strophe.Status.CONNECTED) {
                console.log('Strophe is connected.');
                this.connection.addHandler(onMessage, null, 'message', null, null,  null); 
                this.connection.addHandler(onChangeChatState, null, 'message', 'chat', null,  null); 
                this.connection.addHandler(onSubscriptionRequest, null, "presence", "subscribe");
                this.connection.send($pres().tree());

                LogService.error(this.connection);
                this.loadRoster();

                var cachedResponseRsm = null;

                var jid = 'admin@192.168.4.112';

                // Retrieve a max of 1 collections.
                var rsm = new Strophe.RSM({max: 1});

                this.connection.archive.listCollections(jid, rsm, function (collections, responseRsm) {
                    //get last collection 
                    var lastCollection = collections[collections.length - 1]; 
                    //get last 10 msgs (or all if you please) 
                    rsm = new Strophe.RSM({ 'max': 10, 'before': '' }); 
                    lastCollection.retrieveMessages(null, function (messages, responseRsm) {
                        debugger
                         //Here proceed with list of messages
                     });
            });
            }
        }

        const onChangeChatState = (msg) => {
            const composing = $(msg).find('composing');
            const paused = $(msg).find('paused');
            const active = $(msg).find('active');
            const jid = $(msg).attr('from');

                if (composing.length > 0)
                {
                }

                if (paused.length > 0)
                {
                }

                if (active.length > 0)
                {
                }

            return true;
        }

        const onMessage = (msg) => {
            var to = msg.getAttribute('to');
            var from = msg.getAttribute('from');
            var type = msg.getAttribute('type');
            var elems = msg.getElementsByTagName('body');
        
            if (type == "chat" && elems.length > 0) {
            var body = elems[0];
        
            console.log('ECHOBOT: I got a message from ' + from + ': ' + 
                Strophe.getText(body));
                
            var reply = $msg({to: from, from: to, type: 'chat'})
                        .cnode(Strophe.copyElement(body));
            //this.connection.send(reply.tree());
        
            console.log('ECHOBOT: I sent ' + from + ': ' + Strophe.getText(body));
            }
        
            // we must return true to keep the handler alive.  
            // returning false would remove it after it finishes.
            return true;
        }

        const onSubscriptionRequest = (stanza) => {
            LogService.success(stanza);
            //Handling subscribe request ... ie freind request
            if(stanza.getAttribute("type") == "subscribe" /*&& !is_element_map(stanza.getAttribute("from"))*/) {
                //the friend request is recieved from Client 2
                
                //Creats a ionic popup
            //     var confirmPopup = $ionicPopup.confirm({
            //         title: 'Confirm Friend Request!',
            //         template: ' ' + stanza.getAttribute("from")+' wants to be your freind'
            //     });
                
                
            //     // Yes or No option
            // confirmPopup.then(function(res) {
            //     if(res) {
            //     //Inorder to say that you have accepted their friend request, you just have to send them a 'presence' with 'type = subscribed'
            //     SharedConnObj.connection.send($pres({ to: stanza.getAttribute("from") , type: "subscribed" })); 
                
            //     //Adds the accepted jabber id to the map
            //     push_map( stanza.getAttribute("from") ); 
                
            //     } else {
                
            //     // Rejected the Friend Request
            //     SharedConnObj.connection.send($pres({ to: stanza.getAttribute("from") , type: "unsubscribed" }));
                
            //     }
            // });
                
                return true;
            }
        }

        function rawInput(data) {
            LogService.success('RECV > ' + data);
            LogService.success(data);
        }

        function rawOutput(data) {
            LogService.success('SENT > ' + data);
            LogService.success(data);
        }

        this.connection = new Strophe.Connection(this.BOSH_SERVICE);
        this.connection.rawInput = rawInput;
        this.connection.rawOutput = rawOutput;
        this.connection.connect('addam@192.168.4.112/cnci', 'addam', onConnect);
    }

    sendMessage(from: string, to: string, message: string) {
        // this.connection.send($pres({ to: to + "@192.168.4.112", type: "subscribe" }));
        const reply = $msg({to: to + '@192.168.4.112', from: from + '@192.168.4.112', type: 'chat'}).c("body").t(message);
        this.connection.send(reply.tree());
    }

    loadRoster() {
        let user: User;
        let photo: string;
        const connection = this.connection;
        const getVcard = (stanza) => {
            var $vCard = $(stanza).find("vCard");
            var img = $vCard.find('BINVAL').text();
            var type = $vCard.find('TYPE').text();
            var img_src = 'data:'+type+';base64,'+img;
            XmppService.roster.map(user => user.jid == $($(stanza)[0]).attr('from') ? user.photo = img_src : user);
            //display image using localStorage
            // var ctx = $('#example').get(0).getContext('2d');
            // var img = new Image();   // Create new Image object
            // img.onload = function(){
            //     // execute drawImage statements here
            //     ctx.drawImage(img,0,0)
            // }
            // img.src = img_src;
        };
        //Sends the roster iq (*iq => Information Query)
        const iq = $iq({type: 'get'}).c('query', {xmlns: 'jabber:iq:roster'});
        this.connection.sendIQ(iq,
        //-----------*********Handler function for -> On recieve roster iq****---------------------------//
                function(iq) {
                    if (!iq || iq.length == 0)  // if nothing recieved then send null
                        return;
                    
                    //jquery load data after loading the page.This function updates data after jQuery loading
                        
                        $(iq).find("item").each(function(){
                            user = new User();
                            user.jid = $(this).attr("jid");
                            user.name = $(this).attr("name") || $(this).attr("jid");
                            user.photo = photo;
                            XmppService.roster.push(user);
                            connection.vcard.get(getVcard, user.jid);
                        });		

                        LogService.success(XmppService.roster);
                        
                        return true;
                });
                //------------------------*************END*******----------------------------------------------//
                
                // set up presence handler and send initial presence
                this.connection.addHandler(
                    
                //-----------------****Handler function for -> on recieve precence iq********----------------//
                    function (presence){		
                    //  debugger
                       var from = $(presence).attr('from'); // the jabber_id of the contact
                    //    if (presence_type != 'error'){
                    //      if (presence_type === 'unavailable'){
                    //         console.log("offline"); //alert('offline');
                    //      }else{
                    //        var show = $(presence).find("show").text(); // this is what gives away, dnd, etc.
                    //        if (show === 'chat' || show === ''){
                    //          console.log("online"); //alert('online');
                    //        }else{
                    //          console.log("etc");//alert('etc');
                    //        }
                    //      }
                    //    }
                       return true;
                    }
                //----------------------------------****END****------------------------------------------------//	
                , null, "presence");
                
                this.connection.send($pres());		
        
                this.connection.addHandler(
                
                    //----------------******handler function for on recieve update roster iq****--------------//
                    function(iq) {
                        
                        if (!iq || iq.length == 0)
                            return;
                        
                        //jquery load data after loading the page.This function updates data after jQuery loading
                        // $rootScope.$apply(function() {
                            
                            //Jquery code
                            /*
                            Basically $(iq) is an xml response.
                            find("item") will return the array of <item subscription="value" />
                            each(	function(){}  is used to loop through all items
                            
                            */
                            $(iq).find("item").each( function(){  
                                    // debugger
                                //roster update via Client 1(ie this client) accepting request
                                if($(this).attr("subscription")=="from"){
                                    
                                    // ChatsObj.roster.push({
                                    //     id: $(this).attr("jid"),
                                    //     name:  $(this).attr("name") || $(this).attr("jid"),
                                    //     lastText: 'Available to Chat',
                                    //     face: 'img/ben.png'
                                    // });
                                }
                                
                                // Waiting for the Client 2 to accept the request
                                else if ( $(this).attr("subscription")=="none"  && $(this).attr("ask")=="subscribe" ){
                                    
                                    // ChatsObj.roster.push({
                                    //     id: $(this).attr("jid"),
                                    //     name:  $(this).attr("name") || $(this).attr("jid"),
                                    //     lastText: 'Waiting to Accept',   // Adds roster and waits for the client 2 to accept request
                                    //     face: 'img/ben.png'
                                    // });
                                    
                                    
                                }

                                //roster update via Client 2 deleting the roster contact
                                else if($(this).attr("subscription")=="none"){ 
                                    //Removes the roster
                                    // ChatsObj.removeRoster( ChatsObj.getRoster( $(this).attr("jid") ) );
                                }
                                
                            });
                            
                            //Reloads the page
                            //$state.go('tabsController.chats', {}, {location: "replace", reload: true});
                        
                        // });	
                        return true;
                    }
                //----------------------------------****END****------------------------------------------------//	

                ,"jabber:iq:roster", "iq", "set");
                return true;
}	

    sendComposing() {
        const reply = $msg({to: 'admin@192.168.4.112', type: 'chat'}).c("composing", {xmlns: 'http://jabber.org/protocol/chatstates'});
        this.connection.send(reply.tree());
    }

}
